import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Header2_ScreenContext } from "../header2/header2-context";

declare let window: any;

export interface IStockCountList_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IStockCountList_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  Connect: any;
  Connect_dummy: any;
  InventoryCountHeaderSelect: any[];
  InventoryCountHeaderSelect_dummy: any[];
  InventoryCountListSelect: any[];
  InventoryCountListSelect_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  WriteToLocalStorage: any;
  WriteToLocalStorage_dummy: any;
  HS_StockCountDelete: any[];
  HS_StockCountDelete_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  isComp566666Visible: "visible" | "hidden";
  isComp311499Visible: "visible" | "hidden";
  isComp805680Visible: "visible" | "hidden";
  isComp339512Visible: "visible" | "hidden";
  isComp533841Visible: "visible" | "hidden";
  isComp661748Visible: "visible" | "hidden";
  isComp214651Visible: "visible" | "hidden";
  isComp564525Visible: "visible" | "hidden";
  isComp446873Visible: "visible" | "hidden";
  isComp695009Visible: "visible" | "hidden";
  isComp634264Visible: "visible" | "hidden";
  isComp104431Visible: "visible" | "hidden";
  isComp818738Visible: "visible" | "hidden";
}

export class StockCountList_ScreenBase extends React.PureComponent<
  IStockCountList_ScreenProps,
  any
> {
  static contextType = Header2_ScreenContext;
  declare context: React.ContextType<typeof Header2_ScreenContext>;
  stockcountlist_937692_value_kuikaTableRef: React.RefObject<any>;
  stockcountlist_499225_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "70da2015-72e4-4a73-bc3e-b700175ae3a3",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "b010ea99-bddb-4ee9-865d-c29db9d15911",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 894978, PropertyName: "value", Value: "Sayım" },
        { Id: 190715, PropertyName: "value", Value: "Toplam Sayım" },
        { Id: 15919, PropertyName: "value", Value: "Devam Eden" },
        { Id: 868882, PropertyName: "value", Value: "Tamamlanan" },
        { Id: 120063, PropertyName: "value", Value: "İptal edilen" },
        { Id: 915606, PropertyName: "value", Value: "Fiş Oluştur" },
        { Id: 517724, PropertyName: "value", Value: "Sayım Fişi Numarası" },
        {
          Id: 15924,
          PropertyName: "placeholder",
          Value: "Sayım Fişine Göre Arayınız",
        },
        { Id: 971925, PropertyName: "title", Value: "Title" },
        { Id: 311499, PropertyName: "value", Value: "Geçici Sayım Kodu" },
        { Id: 805680, PropertyName: "value", Value: "ERP Sayım Kodu" },
        { Id: 339512, PropertyName: "value", Value: "[datafield:countno]" },
        {
          Id: 533841,
          PropertyName: "value",
          Value: "[datafield:erpdocumentno]",
        },
        { Id: 789318, PropertyName: "value", Value: "Sayılan Ürün Sayısı" },
        {
          Id: 982471,
          PropertyName: "value",
          Value: "[datafield:totalcountqty]",
        },
        { Id: 798196, PropertyName: "value", Value: "Durum" },
        { Id: 214651, PropertyName: "value", Value: "Devam Ediyor" },
        { Id: 564525, PropertyName: "value", Value: "Tamamlandı" },
        { Id: 446873, PropertyName: "value", Value: "İptal Edildi" },
        { Id: 973362, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 823536,
          PropertyName: "value",
          Value: "[datafield:countstartdate]",
        },
        { Id: 318050, PropertyName: "value", Value: "Bitiş Tarihi" },
        {
          Id: 695009,
          PropertyName: "value",
          Value: "[datafield:countenddate]",
        },
        { Id: 634264, PropertyName: "value", Value: "Devam Eden Sayım" },
        { Id: 490760, PropertyName: "value", Value: "Ofis Kodu" },
        { Id: 581337, PropertyName: "value", Value: "[datafield:officecode]" },
        {
          Id: 600072,
          PropertyName: "value",
          Value: "[datafield:officecodedescription]",
        },
        { Id: 329381, PropertyName: "value", Value: "Mağaza Kodu" },
        { Id: 531184, PropertyName: "value", Value: "[datafield:storecode]" },
        {
          Id: 889565,
          PropertyName: "value",
          Value: "[datafield:storecodedescription]",
        },
        { Id: 187500, PropertyName: "value", Value: "Depo Kodu" },
        {
          Id: 250226,
          PropertyName: "value",
          Value: "[datafield:warehousecode]",
        },
        {
          Id: 750792,
          PropertyName: "value",
          Value: "[datafield:warehousedescription]",
        },
        { Id: 609659, PropertyName: "value", Value: "ERP TRANSFER" },
        { Id: 104431, PropertyName: "value", Value: "EVET" },
        { Id: 818738, PropertyName: "value", Value: "HAYIR" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  private _prevMasterPageInitLoaded: boolean = false;
  private _prevMasterPageRecurringLoaded: boolean = false;
  private _prevShouldTriggerPageInit: boolean = false;
  constructor(props) {
    super(props);
    this.stockcountlist_15924_value_kuikaTextInputRef = React.createRef();
    this.stockcountlist_937692_value_kuikaTableRef = React.createRef();
    this.stockcountlist_499225_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      Connect: "",
      InventoryCountHeaderSelect: [],
      InventoryCountListSelect: [],
      GoBack: "",
      NAVIGATE: "",
      SetValueOf: "",
      WriteToLocalStorage: "",
      HS_StockCountDelete: [],
      Notify: false,
      TriggerEvent: "",
      isComp566666Visible: "hidden",
      isComp311499Visible: "hidden",
      isComp805680Visible: "hidden",
      isComp339512Visible: "hidden",
      isComp533841Visible: "hidden",
      isComp661748Visible: "hidden",
      isComp214651Visible: "hidden",
      isComp564525Visible: "hidden",
      isComp446873Visible: "hidden",
      isComp695009Visible: "hidden",
      isComp634264Visible: "hidden",
      isComp104431Visible: "hidden",
      isComp818738Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight(
        "stockcountlist",
        "header2_screen"
      );
      return;
    }
    this.context.registerCallbackFunction(this.callCallbackFunction.bind(this));

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (false) {
      await this.StockCountListPageInit();
    } else if (this.context?.isMasterPageInitLoaded) {
      this._prevMasterPageInitLoaded = true;
      await this.StockCountListPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountlist",
      "header2_screen"
    );

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight(
      "stockcountlist",
      "header2_screen"
    );
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.StockCountListPageInit();
    }

    if (
      this._prevMasterPageInitLoaded !== this.context.isMasterPageInitLoaded &&
      this.context.isMasterPageInitLoaded === true
    ) {
      this._prevMasterPageInitLoaded = this.context.isMasterPageInitLoaded;
      await this.StockCountListPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  StockCountListPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      CountNo_2: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountList/StockCountListPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InventoryCountHeaderSelect =
      result?.data.inventoryCountHeaderSelect;
    formVars.stockcountlist_110434_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].toplamSayim
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].toplamSayim
        : null
    );
    formVars.stockcountlist_936721_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].devamEden
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].devamEden
        : null
    );
    formVars.stockcountlist_226461_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].tamamlanan
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].tamamlanan
        : null
    );
    formVars.stockcountlist_247130_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].iptalEdilen
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].iptalEdilen
        : null
    );
    stateVars.InventoryCountListSelect = result?.data.inventoryCountListSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountListPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountListPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.stockcountlist_110434_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].toplamSayim
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].toplamSayim
        : null
    );

    formVars.stockcountlist_936721_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].devamEden
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].devamEden
        : null
    );

    formVars.stockcountlist_226461_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].tamamlanan
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].tamamlanan
        : null
    );

    formVars.stockcountlist_247130_value = ReactSystemFunctions.toString(
      this,
      stateVars.InventoryCountHeaderSelect !== undefined
        ? stateVars.InventoryCountHeaderSelect?.length > 0
          ? stateVars.InventoryCountHeaderSelect[0].iptalEdilen
          : null
        : this.state.InventoryCountHeaderSelect?.length > 0
        ? this.state.InventoryCountHeaderSelect[0].iptalEdilen
        : null
    );

    stateVars.dataSource_937692 =
      stateVars.InventoryCountListSelect ?? this.state.InventoryCountListSelect;
    stateVars.isComp311499Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp805680Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp339512Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp533841Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp661748Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp214651Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "statuCode"
        ),
        ReactSystemFunctions.convertToTypeByName("InProgress", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp564525Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "statuCode"
        ),
        ReactSystemFunctions.convertToTypeByName("Completed", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp446873Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "statuCode"
        ),
        ReactSystemFunctions.convertToTypeByName("Canceled", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp695009Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "countEndDate"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp634264Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "countEndDate"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp104431Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp818738Visible =
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          "stockcountlist_937692_value",
          "erpDocumentNo"
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.stockcountlist_499225_total = ReactSystemFunctions.value(
      this,
      stateVars.InventoryCountListSelect !== undefined
        ? stateVars.InventoryCountListSelect?.length > 0
          ? stateVars.InventoryCountListSelect[0].totalRowCount
          : null
        : this.state.InventoryCountListSelect?.length > 0
        ? this.state.InventoryCountListSelect[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  StockCountListComponent_566666_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountListComponent_399363_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/stockcountheader") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "StockCountList",
      "StockCountHeader",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountListComponent_15924_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CountNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountlist_15924_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountList/StockCountListComponent_15924_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InventoryCountListSelect = result?.data.inventoryCountListSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.StockCountListComponent_15924_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountListComponent_15924_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "stockcountlist_499225_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );

    stateVars.dataSource_937692 =
      stateVars.InventoryCountListSelect ?? this.state.InventoryCountListSelect;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountListComponent_992164_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.WriteToLocalStorage =
      await ReactSystemFunctions.writeToLocalStorage(
        ReactSystemFunctions.convertToTypeByName("CountHeaderId", "string"),
        ReactSystemFunctions.value(this, "stockcountlist_937692_value", "id")
      );
    const __currentPath = (
      window.location.hash
        ? window.location.hash.replace(/^#/, "").split("?")[0]
        : window.location.pathname.split("?")[0]
    ).toLowerCase();
    if (__currentPath !== "/stockcountdetail") {
      this.context.setMasterPageInitLoaded(false);
      this.context.setMasterPageRecurringLoaded(false);
      this.context.setShouldTriggerPageInit(true);
    }
    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "StockCountDetail",
      "StockCountHeaderId",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stockcountlist_937692_value", "id"),
        "Guid"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "StockCountList",
      "StockCountDetail",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountListComponent_661748_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "stockcountlist_937692_value", "id"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "35dac9ca_1eb5_1fd9_a189_e996f92c6fc8_confirmation",
        this.defaultML,
        "Sayımı silmek istediğinize emin misiniz? Bu işlem geri alınamaz."
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "StockCountList/StockCountListComponent_661748_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.HS_StockCountDelete = result?.data.hS_StockCountDelete;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.StockCountListComponent_661748_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountListComponent_661748_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.toString(
        this,
        stateVars.HS_StockCountDelete !== undefined
          ? stateVars.HS_StockCountDelete?.length > 0
            ? stateVars.HS_StockCountDelete[0].message
            : null
          : this.state.HS_StockCountDelete?.length > 0
          ? this.state.HS_StockCountDelete[0].message
          : null
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    await this.StockCountListPageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  StockCountListComponent_499225_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      CountNo_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      PageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "stockcountlist_499225_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "StockCountList/StockCountListComponent_499225_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InventoryCountListSelect = result?.data.inventoryCountListSelect;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.StockCountListComponent_499225_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  StockCountListComponent_499225_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_937692 =
      stateVars.InventoryCountListSelect ?? this.state.InventoryCountListSelect;
    formVars.stockcountlist_499225_total = ReactSystemFunctions.value(
      this,
      stateVars.InventoryCountListSelect !== undefined
        ? stateVars.InventoryCountListSelect?.length > 0
          ? stateVars.InventoryCountListSelect[0].totalRowCount
          : null
        : this.state.InventoryCountListSelect?.length > 0
        ? this.state.InventoryCountListSelect[0].totalRowCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.StockCountListPageInit();
    }
  }
}
